import type React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import TempPasswordRedirect from "./TempPasswordRedirect";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowTempPassword?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowTempPassword = false }) => {
  const { isAuthenticated, loading, user } = useSelector((state: RootState) => state.user);
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (!isAuthenticated) {
    // Redirect to login page but save the attempted url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user has temporary password and the route doesn't allow it, redirect to password reset
  if (user?.isTempPassword && !allowTempPassword) {
    return <TempPasswordRedirect />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
